<template>
  <button-base medium="bluesky" :title="i18n.t('public.social.share_on_bluesky')" class="bluesky"
               @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import BlueskyMixin from '@/share/campaign/bluesky-mixin'

export default {
  components: { ButtonBase },

  mixins: [BlueskyMixin]
}
</script>
